import { DefaultService } from '@/services/DefaultService';

export default class AssClienteLicencaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAllVendas(column, order, page, limit, situacao, id, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/cliente/assclientelicenca.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllAgro(column, order, page, limit, situacao, id, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/cliente/assclientelicenca.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacaoVendas(assClienteUsuario) {
        return this._http.post(`${this._env}/ven/cliente/assclientelicenca/updatesituacao`, assClienteUsuario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(assClienteUsuario) {
        return this._http.post(`${this._env}/agro/cliente/assclientelicenca/updatesituacao`, assClienteUsuario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosVendas(column, order, page, limit, id, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/cliente/assclientelicenca/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosAgro(column, order, page, limit, id, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/cliente/assclientelicenca/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findVendas(id) {
        return this._http.get(`${this._env}/ven/cliente/assclientelicenca/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAgro(id) {
        return this._http.get(`${this._env}/agro/cliente/assclientelicenca/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveVendas(lista) {
        return this._http.post(`${this._env}/ven/cliente/assclientelicenca`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(lista) {
        return this._http.post(`${this._env}/agro/cliente/assclientelicenca`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}